var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAtacado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 274.01 53.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dcc6b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M609.85,443.64h11.07l10.2,52.08H623l-2.62-13.55h-11l-2.48,13.55h-7.57Zm9.18,31.9-4-22.65h-.22l-4.15,22.65Z",
    transform: "translate(-549.93 -442.98)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M641.17,450.7h-9.91v-6.92h27.83v6.92h-9.76v45h-8.16Z",
    transform: "translate(-549.93 -442.98)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M669.8,443.64h11.07l10.2,52.08h-8.16l-2.62-13.55h-11l-2.48,13.55h-7.57Zm9.18,31.9-4-22.65h-.22l-4.15,22.65Z",
    transform: "translate(-549.93 -442.98)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M694.93,483.85V455.58c0-7.86,5.83-12.6,13.84-12.6,7.51,0,12.82,4.45,12.82,11.58v5.76h-7.35v-4.88c0-3.28-2-5.46-5.47-5.46-3.93,0-5.68,2.47-5.68,5.9v27.46c0,3.86,2.19,6,5.76,6a5,5,0,0,0,5.39-5.39V479h7.35v5.32c0,7.43-5.31,12.09-12.82,12.09C700.61,496.45,694.93,492.15,694.93,483.85Z",
    transform: "translate(-549.93 -442.98)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M736.6,443.64h11.07l10.2,52.08h-8.16l-2.62-13.55h-11l-2.48,13.55H726Zm9.18,31.9-4-22.65h-.22l-4.15,22.65Z",
    transform: "translate(-549.93 -442.98)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M763.33,443.78H777c7.35,0,13.11,3.86,13.11,11.8v27.69c0,8.45-5.76,12.45-13.19,12.45H763.33Zm12.9,45c4.22,0,5.68-3.06,5.68-5.83V456.39c0-3.14-1.75-5.61-5.68-5.61h-4.74v38Z",
    transform: "translate(-549.93 -442.98)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M796.19,483.19V456.24c0-8.67,6-13.26,13.91-13.26,7.72,0,13.84,4,13.84,12.82V483c0,9-6.12,13.48-13.91,13.48C801.8,496.45,796.19,492.15,796.19,483.19Zm19.59.15V455.66c0-3.43-2.18-5.61-5.75-5.61s-5.68,2.47-5.68,5.75v27.54c0,3.28,2,5.9,5.75,5.9S815.78,486.62,815.78,483.34Z",
    transform: "translate(-549.93 -442.98)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    className: "cls-1",
    d: "M593.31,471.34H576.63V488a3.34,3.34,0,0,1-6.68,0h0V471.34H553.26a3.34,3.34,0,0,1,0-6.67H570V448a3.34,3.34,0,1,1,6.67,0h0v16.68h16.69a3.34,3.34,0,0,1,0,6.68Z",
    transform: "translate(-549.93 -442.98)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAtacado);
export default __webpack_public_path__ + "static/media/logoAtacado.1fea63b82b25105ccfc9e31996141de8.svg";
export { ForwardRef as ReactComponent };